import { render, staticRenderFns } from "./VerifyDialog.vue?vue&type=template&id=5cfd4f06&scoped=true"
import script from "./VerifyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VerifyDialog.vue?vue&type=style&index=0&id=5cfd4f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd4f06",
  null
  
)

export default component.exports